import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Reusable portal file-upload button. Posts multipart/form-data to `endpoint`.
export const PortalUpload = ({
  endpoint,
  fields = {},
  onUploaded,
  label = "Upload",
  testid = "portal-upload-button",
  variant = "primary",
  accept,
}) => {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      Object.entries(fields).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") fd.append(k, v);
      });
      await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("File uploaded");
      onUploaded?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      <Button
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        data-testid={testid}
        variant={variant === "primary" ? "default" : "outline"}
        className={variant === "primary" ? "text-white" : ""}
        style={variant === "primary" ? { backgroundColor: "var(--mmm-red)" } : {}}
      >
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Upload size={16} className="mr-2" />}
        {label}
      </Button>
    </>
  );
};
